import { useState } from "react";
import ContactClasses from "./Login.module.css";
import Layout from "Components/Layouts/Common/common";
import { useForm, SubmitHandler } from "react-hook-form";
import CustomButton from "Components/Button";
import { NavLink } from "react-router-dom";
import { PiEyeClosedBold, PiEyeSlash } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import ApiService from "Services/config";
import { Login, forgot_sendOtp, forgot_verify } from "Services/Requests";
import { ProgressBar } from "react-loader-spinner";
import OtpInput from "react-otp-input";
import { showSuccessNotification } from "Utils/Notifications";
import { useSearchParams } from "react-router-dom";
// import ApiService from "Services/config";
type Inputs = {
    email: string;
    password: string;
    confirmPassword: string;
};
function Contact() {
    const navigate = useNavigate();
    const [otp, setOtp] = useState("");
    const [searchParams] = useSearchParams();
    const [errorMessage, setErrorMsg] = useState("");
    const [Loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [sendOtp, setsendotp] = useState(false);
    const [showconfirm, setShowconfirm] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<Inputs>();
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (data.confirmPassword != data.password) {
            setErrorMsg("password and confirm password must be same");
            return;
        }
        ApiService.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${searchParams.get("token")}`;
        try {
            const response = await forgot_verify({
                password: data?.password,
            });
            setLoading(false);
            console.log(response.data.user);
            if (response?.data?.Status === 1) {
                // setError("");
                showSuccessNotification(
                    "Password changed successfully please login"
                );
                navigate("/login");
            } else {
                setErrorMsg(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            console.log(err);
            setErrorMsg(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };
    return (
        <Layout>
            <div className={ContactClasses["Container"]}>
                <header>
                    <h3>Reset password</h3>
                </header>
                <div className={ContactClasses["Form_wrapper"]}>
                    <h3>Reset password</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={ContactClasses["form-control"]}>
                            <label htmlFor="">Password</label>
                            <div className={ContactClasses["input-wrapper"]}>
                                <input
                                    type={show ? "text" : "password"}
                                    placeholder="Enter Your Password"
                                    {...register("password", {
                                        required: true,
                                    })}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShow((prev) => !prev)}>
                                    {!show ? (
                                        <PiEyeClosedBold />
                                    ) : (
                                        <PiEyeSlash />
                                    )}
                                </button>
                            </div>
                            {errors.password && <p>Password is required</p>}
                        </div>
                        <div className={ContactClasses["form-control"]}>
                            <label htmlFor="">confirm Password</label>
                            <div className={ContactClasses["input-wrapper"]}>
                                <input
                                    type={showconfirm ? "text" : "password"}
                                    placeholder="Enter Your Password"
                                    {...register("confirmPassword", {
                                        required:
                                            "confirm Password is required",
                                    })}
                                />
                                <button
                                    type="button"
                                    onClick={() =>
                                        setShowconfirm((prev) => !prev)
                                    }>
                                    {!show ? (
                                        <PiEyeClosedBold />
                                    ) : (
                                        <PiEyeSlash />
                                    )}
                                </button>
                            </div>
                            {errors.confirmPassword && (
                                <p>{errors?.confirmPassword.message}</p>
                            )}
                        </div>

                        {errorMessage && (
                            <p className={ContactClasses["login-error"]}>
                                {errorMessage}
                            </p>
                        )}
                        {Loading ? (
                            <div
                                style={{
                                    gridColumn: "1/-1",
                                    justifySelf: "center",
                                }}>
                                <ProgressBar
                                    visible={true}
                                    height="80"
                                    width="80"
                                    barColor="#ccc"
                                    borderColor="lightblue"
                                    ariaLabel="progress-bar-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                                {/* <button type=""></button> */}
                            </div>
                        ) : (
                            <CustomButton
                                Title={"Change Password"}
                                Theme="Dark"
                                type="submit"
                            />
                        )}
                    </form>
                </div>
            </div>
        </Layout>
    );
}

export default Contact;
